import {UnAuthenticated} from "@/components/common/UnAuthenticated";
import {Stack} from "expo-router";

export default function LoginLayout() {
    return (
        <UnAuthenticated>
            <Stack screenOptions={{headerShown: false}}/>
        </UnAuthenticated>
    );
}
